module.exports = __webpack_public_path__ + "static/media/logo_blue.d3ae50b1.svg";